<template>
  <v-data-table
    v-if="items.length > 0"
    :items="items"
    :headers="tableHeaders"
    hide-default-footer
  >
    <template v-slot:[`item.name`]="{item}">
      <material-card :product="item" :value="item.value" @input="save(item, $event)"></material-card>
    </template>
    <template v-slot:[`item.count`]="{item}">
      {{ item.value }}
      <template v-if="item.unitName != item.productUnitName">
        ({{ (item.value * item.productUnitSize).toFixed(2) }} {{item.unitName}})
      </template>
    </template>
    <template v-slot:[`item.totalPrice`]="{item}">
      {{ (item.value * item.pricePerUnit).toFixed(2) }} &#8381;
    </template>
    <template v-slot:[`item.actions`]="{item}">
      <v-btn @click="deleteItem(item._id)" icon><v-icon>mdi-delete</v-icon></v-btn>
    </template>
    <template v-slot:footer>
      <div class="pl-2 pt-3">
        Выбрано {{ productsCount }} товар(ов) 
        <template v-if="category.unitName != category.productUnitName">
          [{{ productUnitsCount }} {{ category.unitName }}]
        </template> 
        на сумму <strong>{{ productsCost }}</strong> &#8381;
      </div>
    </template>
  </v-data-table>
</template>

<script>
import _ from 'lodash';
import MaterialCard from './ConstructorMaterialCard';

export default {
  name: 'selected-materials',

  props: {
    value: Array,
    category: Object
  },

  components: {
    MaterialCard
  },

  data() {
    return {
      tableHeaders: [
        {
          text: 'Наименование',
          value: 'name'
        },
        {
          text: 'Ед.изм.',
          value: 'productUnitName'
        },
        {
          text: 'Цена за ед.',
          value: 'pricePerUnit'
        },
        {
          text: 'Кол-во',
          value: 'count'
        },
        {
          text: 'Стоимость',
          value: 'totalPrice'
        },
        {
          text: '',
          value: 'actions'
        }
      ],
    }
  },

  methods: {
    deleteItem(id) {
      //let newValue = _.cloneDeep(this.value);
      let elem = this.value.find(x => x._id == id);
      elem.value = 0;
      elem._value = 0;
      //this.$emit('input', newValue);
    },
    save(item, val) {
      item.value = val;
      item._value = val;
    }
  },

  computed: {
    items() {
      return this.value.filter(x => x.value > 0);
    },
    productsCount() {
      return this.value.reduce((sum, cur) => sum + Number(cur._value), 0);
    },
    productsCost() {
      return this.value.reduce((sum, cur) => sum + Number(cur._value) * Number(cur.pricePerUnit), 0).toFixed(2);
    },
    productUnitsCount() {
      return this.value.reduce((sum, cur) => sum + Number(cur._value) * Number(cur.productUnitSize), 0).toFixed(2);
    }
  }
}
</script>